import { apiRequest } from "../apiRequest";

type CalendarCheckResponse = {
  calendarScope: boolean;
};
export async function checkCalendarAccess(): Promise<boolean> {
  const { calendarScope } = await apiRequest<CalendarCheckResponse>({ url: "auth/google/calendarScope" });
  return calendarScope;
}
